export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.hook("apollo:auth", ({ token }) => {
    token.value = nuxtApp.$store.state?.provider?.token ?? null;
  });
});
